import React, { useEffect, useState } from "react";
import Sidebar from "../sidebar/Sidebar";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Navbar from "../header/Navbar";
import AvatarPopover from "../../commonComponent/AvtarPopover";
import ApiConfig from "../../config/ApiConfig";
import { useHover } from "../../customHook/useHover";
import {
  formatDate,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import { updateParticipantsStatus } from "../../services/AppointmentService";
import Loader from "../../commonComponent/Loader";
import { confirmBookingStatus } from "../../services/DoctorService";
import { createZoomMeetingService } from "../../services/ZoomService";

const GroupAppointment = () => {
  const navigate = useNavigate();
  const { hoveredUserId, handleMouseEnter, handleMouseLeave } = useHover();
  const location = useLocation();
  const { appointment, isFromSchedule } = location?.state;
  const [participants, setParticpants] = useState([]);
  const [acceptedUserList, setAcceptedUserList] = useState([]);
  const [declinedUserList, setDeclinedUserList] = useState([]);

  useEffect(() => {
    setParticpants(appointment.users);
    setAcceptedUserList(
      appointment.users
        .filter((user) => {
          if (user.status === "accept") {
            return user.userId;
          }
        })
        .map((user) => user.userId)
    );
    setDeclinedUserList(
      appointment.users
        .filter((user) => {
          if (user.status === "decline") {
            return user.userId;
          }
        })
        .map((user) => user.userId)
    );
  }, []);

  // console.log(acceptedUserList, declinedUserList, 'list for both', appointment)

  const createMeeting = async (request, user) => {
    try {
      // const time24h = request?.startTime?.split('-')?.[0]?.trim();
      const params = {
        topic: "Doctor appointment",
        type: 2,
        start_time: request.startTime,
        duration: "30",
        settings: {
          host_video: true,
          participant_video: true,
          join_before_host: true,
          mute_upon_entry: "true",
          watermark: "true",
          audio: "voip",
          auto_recording: "cloud",
          email_notification: true,
          registrants_email_notification: true,
          meeting_invitees: [
            {
              email: user?.email,
            },
          ],
        },
      };
      const meetingResponse = await createZoomMeetingService(params);
      if (meetingResponse) {
        return meetingResponse;
      }
    } catch (error) {
      if (error?.data?.data) {
        navigate("/myprofile");
        showToastError(
          error?.data?.data || error.data?.message || "Some error occurred"
        );
      }
    }
  };

  const confirmBooking = async (user) => {
    const meetingResponse = await createMeeting(appointment, user);
    if (meetingResponse) {
      var sessionLink_doctor1 = meetingResponse.start_url;
      var sessionLink_user1 = meetingResponse.join_url;
    }
    try {
      const response = await confirmBookingStatus({
        bookingId: appointment._id,
        status: "confirmed",
        sessionLink_doctor: sessionLink_doctor1,
        sessionLink_user: sessionLink_user1,
      });
      if (response.status === 200) {
        showToastSuccess(response?.data?.message);
      } else {
        showToastError(response?.data || response.message);
      }
    } catch (error) {
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
    }
  };

  const handlestatusChange = async (status, appointId, userId, user) => {
    if (acceptedUserList.length === 0 && status === "accept") {
      confirmBooking(user);
    }
    try {
      if (status && appointId && userId) {
        const response = await updateParticipantsStatus(
          status,
          appointId,
          userId
        );
        if (response.status !== 200) return;
        if (status === "accept") {
          setAcceptedUserList([...acceptedUserList, userId]);
        } else if (status === "decline") {
          setDeclinedUserList([...declinedUserList, userId]);
        }
        showToastSuccess(response?.data);
      } else {
        console.error("somethin is wrong");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Navbar />

      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-5">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate("/")}
                >
                  Home
                </li>
                {isFromSchedule ? (
                  <li
                    className="breadcrumb-item  cursor-pointer"
                    aria-current="page"
                    onClick={() => navigate("/calender?tab=1")}
                  >
                    Schedule
                  </li>
                ) : (
                  <li
                    className="breadcrumb-item  cursor-pointer"
                    aria-current="page"
                    onClick={() => navigate("/todayappointment")}
                  >
                    Appointments
                  </li>
                )}
                <li
                  className="breadcrumb-item active fw-bold cursor-pointer"
                  aria-current="page"
                >
                  Group Appointments Participants
                </li>
              </ol>
            </nav>
            <section>
              <Tabs>
                <TabList>
                  <Tab>
                    <span>Group appointment participants</span>
                  </Tab>
                </TabList>

                <TabPanel>
                  {participants.length > 0 ? (
                    participants.map(
                      (dt) =>
                        (dt.status === "accept" ||
                          dt.status === "" ||
                          dt.status === "decline") && (
                          <div
                            key={dt?.userId}
                            className="card shadow-sm border-0 mb-3 p-3 d-flex flex-md-row justify-content-between"
                          >
                            <div
                              className="d-flex align-items-center avatar_warper"
                              onMouseEnter={() => handleMouseEnter(dt?.userId)}
                              onMouseLeave={handleMouseLeave}
                            >
                              {dt?.profilePicture ? (
                                <img
                                  src={`${ApiConfig.ImageUrl}user/${dt?.userId}/${dt?.profilePicture}`}
                                  className="recipe_image_ me-4"
                                  alt=""
                                  onError={(e) =>
                                    (e.target.src = "images/avatar.png")
                                  }
                                />
                              ) : (
                                <img
                                  src="images/avatar.png"
                                  className="recipe_image_ me-4"
                                  alt=""
                                />
                              )}
                              <AvatarPopover
                                data={dt}
                                onHover={dt?.userId === hoveredUserId}
                              />

                              <div className="">
                                <p className="m-0">{dt.full_name}</p>
                              </div>
                            </div>
                            <div className="d-flex justify-content-around align-items-center">
                              {dt.status === "" &&
                                !acceptedUserList.includes(dt?.userId) &&
                                !declinedUserList.includes(dt?.userId) && (
                                  <>
                                    {" "}
                                    <button
                                      className="btn btn-success me-2"
                                      onClick={() => {
                                        handlestatusChange(
                                          "accept",
                                          appointment._id,
                                          dt?.userId,
                                          dt
                                        );
                                      }}
                                    >
                                      Accept
                                    </button>
                                    <button
                                      className="btn btn-danger "
                                      onClick={() => {
                                        handlestatusChange(
                                          "decline",
                                          appointment._id,
                                          dt?.userId
                                        );
                                      }}
                                    >
                                      Decline
                                    </button>
                                  </>
                                )}
                              {acceptedUserList.includes(dt?.userId) && (
                                <span className="text-success">Accepted</span>
                              )}
                              {declinedUserList.includes(dt?.userId) && (
                                <span className="text-danger">Declined</span>
                              )}
                              {/* <Link className="btn btn-primary btn-custom-light ms-3" to={`/EditRecipe?recipeId=${dt._id}`}>
                          <span><RiEdit2Fill className="me-2" />Edit</span>
                        </Link> */}
                            </div>
                          </div>
                        )
                    )
                  ) : (
                    <Loader
                      visible={false}
                      mainStyle={{ height: "500px" }}
                      noAnyData={!(participants.length > 0)}
                    />
                  )}
                </TabPanel>
              </Tabs>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupAppointment;
